import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/SCMTypes";

//供应商信息
export interface IVRMSupplierInfo {
    contact: string,
    phone: string,
    note: string
}

//详情
export interface IVRMSupplierDetail {
    id?: string
    code?: string
    branch?: string
    ver?: number
    enable?: number
    orgCode?: string | null
    orgName?: string | null
    shopId?: string | null
    shopName?: string | null
    linkCode?: string | null
    name?: string
    typeCode?: string | number
    typeName?: string | number
    level?: number
    contact?: string
    phone?: string
    tel?: string
    fax?: string
    email?: string
    website?: string
    address?: string
    invoiceTitle?: string | null
    licenseNo?: string | null
    bank?: string
    bankAcct?: string | null
    bankPhone?: string | null
    postAddress?: string | null
    corporation?: string
    businessScope?: string
    status?: number
    note?: string
    staffCode?: string | null
    staffName?: string | null
    attrCode?: string | null
    attrName?: string | null
    isInternal?: string | null
    createTime?: string
    createUser?:string,
    updateTime?: string
    updateUser?:string,
    categoryCode?:string
    categoryName?:string    
}

//搜索条件
export interface IVRMSupplierSearchFields {
    shopId?: string,
    code?: string,
    name?: string,
    contact?: string,
    phone?: string,
    enable?: number,
}

export interface IVRMSupplierSearch
    extends IVRMSupplierSearchFields, ISearchPage {

}
export interface paramsDisable {
    id:string,
    enable:number
}

class SupplierService {
    async page(searchVo: IVRMSupplierSearch) {
        const apiUrl = "/vrm-sa/base/supplier/findPage";
        return await httpRequest.post<IPage<IVRMSupplierDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/base/supplier/findById/${id}`;
        return await httpRequest.get<IVRMSupplierDetail>(apiUrl);
    }
    async insert(insertVo: IVRMSupplierDetail) {
        const apiUrl = "/vrm-sa/base/supplier/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IVRMSupplierDetail) {
        const apiUrl = "/vrm-sa/base/supplier/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(params:paramsDisable) {
        const apiUrl = `/vrm-sa/base/supplier/change`;
        return await httpRequest.post<boolean>(apiUrl,params);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/vrm-sa/base/supplier/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IVRMSupplierSearch) {
        const appPageUrl = "/vrm-sa/base/supplier/export";
        return await httpRequest.postFile(appPageUrl, searchVo,{ timeout: 600000 });
    }
    //供应商转客户
    async transfer(id: string) {
        const appPageUrl = `/vrm-sa/base/supplier/transfer/${id}`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/vrm-sa/base/supplier/downloadTpl";
        return await httpRequest.getFile<boolean>(appPageUrl);
    }
}

export const supplierService = new SupplierService();
